import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "layout-row items-center flex-grow justify-center md:justify-between max-w-[1044px]" };
const _hoisted_2 = {
    key: 0,
    class: "px-md absolute left-0 right-0 top-sm"
};
const _hoisted_3 = { class: "layout-row items-center flex-grow justify-center md:justify-between max-w-[1044px]" };
const _hoisted_4 = {
    key: 0,
    class: "flex h-[504px] w-[492px] justify-center items-center"
};
const _hoisted_5 = {
    key: 1,
    class: "form layout-column p-md sm:p-0 sm:w-[343px] md:w-[352px]"
};
const _hoisted_6 = { class: "typography-display-small mb-md text-center md:text-left" };
const _hoisted_7 = { class: "typography-body-2-regular mb-xl text-center md:text-left" };
const _hoisted_8 = { class: "typography-body-2-bold" };
const _hoisted_9 = {
    key: 2,
    class: "form layout-column p-md sm:p-0 gap-xl sm:w-[343px] md:w-[352px]"
};
const _hoisted_10 = { class: "layout-column gap-md items-center md:items-stretch" };
const _hoisted_11 = { class: "typography-display-small dark:text-on-background-dark text-center" };
const _hoisted_12 = {
    key: 0,
    class: "typography-body-2-regular dark:text-on-background-dark text-center md:text-start"
};
const _hoisted_13 = {
    key: 1,
    class: "typography-body-2-regular dark:text-on-background-dark"
};
const _hoisted_14 = { class: "typography-body-2-bold" };
const _hoisted_15 = {
    key: 0,
    class: "layout-column gap-md"
};
const _hoisted_16 = { class: "layout-row justify-between gap-md" };
const _hoisted_17 = { class: "button-wrapper layout-column gap-md" };
const _hoisted_18 = { class: "layout-column gap-md" };
const _hoisted_19 = { class: "layout-row gap-md justify-between md:justify-end" };
import { OrButtonV3 as OrButton, OrInputV3 as OrInput, OrCheckboxV3 as OrCheckbox, OrModalV3 as OrModal, OrNotificationV3 as OrNotification, useResponsive, } from '@onereach/ui-components';
import { nextTick, ref, watch } from 'vue';
import GoogleLogin from '../Auth/GoogleLogin.vue';
import PasswordRecovery from '../Auth/PasswordRecovery.vue';
import OrAnimationLogo from '../OrAnimationLogo/OrAnimationLogo.vue';
import OrLogo from '../OrLogo';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExpireSignIn',
    props: {
        twoFactorCheck: { type: Boolean },
        titleText: {},
        error: { type: [String, Boolean] },
        loading: { type: Boolean },
        userIdentityProvider: { type: [Boolean, String, null] },
        username: {},
        googleLogin: { type: Boolean },
        ssoError: { type: [String, Boolean] },
        googleLoading: { type: Boolean },
        keepLoggedIn: { type: Boolean },
        redirectPath: {}
    },
    emits: ["submit", "logout", "dismissSso", "providerLogin", "update:keepLoggedIn"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const password = ref('');
        const verificationCode = ref('');
        const recoveryCode = ref('');
        const isOpenRecovery2fa = ref(false);
        const rememberTwoFactor = ref(false);
        const { isDesktop } = useResponsive();
        const submit = () => {
            recoveryError.value = '';
            const credentials = {
                username: props.username,
                password: password.value,
            };
            const requestData = {
                credentials,
                keepLoggedIn: props.keepLoggedIn,
                rememberTwoFactor: rememberTwoFactor.value,
            };
            const twoFactorCode = isOpenRecovery2fa.value ? recoveryCode.value : verificationCode.value;
            emit('submit', requestData, isOpenRecovery2fa.value, twoFactorCode);
        };
        watch(verificationCode, (value) => {
            if (value.length === 6) {
                submit();
            }
        });
        const logout = () => {
            emit('logout');
        };
        const dismissSso = () => {
            emit('dismissSso');
        };
        const recoveryError = ref('');
        const toogleOpenRecovery2fa = (boolean) => {
            isOpenRecovery2fa.value = boolean;
            if (!boolean) {
                recoveryCode.value = '';
                recoveryError.value = '';
            }
        };
        const resetPasswordModal = ref(null);
        const showForgotPopup = () => {
            var _a;
            (_a = resetPasswordModal.value) === null || _a === void 0 ? void 0 : _a.open();
        };
        const loginWithProvider = () => {
            emit('providerLogin');
        };
        const updateKeepLoggedIn = (bool) => {
            emit('update:keepLoggedIn', bool);
        };
        watch(() => props.error, (value) => {
            if (isOpenRecovery2fa.value) {
                recoveryError.value = value;
            }
        });
        const twoFactorInput = ref(null);
        watch(() => props.twoFactorCheck, (value) => {
            if (value) {
                nextTick(() => {
                    var _a;
                    (_a = twoFactorInput.value) === null || _a === void 0 ? void 0 : _a.focus();
                });
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.ssoError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_unref(OrNotification), {
                            class: "sm:max-w-[768px] mx-auto",
                            variant: "error",
                            onClose: dismissSso
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.ssoError), 1)
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                    (_unref(isDesktop))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(OrAnimationLogo)
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.twoFactorCheck)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_unref(OrLogo), { class: "self-center md:hidden mb-md" }),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('login.login.twofactorVerification')), 1),
                            _createElementVNode("span", _hoisted_7, [
                                _createTextVNode(_toDisplayString(_ctx.$t('login.login.Your profile')) + " ", 1),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.username), 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('login.login.has been configured to use two-factor authentication')), 1)
                            ]),
                            _createVNode(_unref(OrInput), {
                                ref_key: "twoFactorInput",
                                ref: twoFactorInput,
                                modelValue: verificationCode.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((verificationCode).value = $event)),
                                label: _ctx.$t('login.login.verificationCode'),
                                placeholder: _ctx.$t('login.login.Enter Verification Code'),
                                loading: _ctx.loading,
                                class: "username mb-xl",
                                error: _ctx.error,
                                name: "verificationCode",
                                onKeyup: _withKeys(submit, ["enter", "native"])
                            }, null, 8, ["modelValue", "label", "placeholder", "loading", "error"]),
                            _createVNode(_unref(OrButton), {
                                class: "sign-in md:self-start mb-xl",
                                variant: "link",
                                onClick: _cache[1] || (_cache[1] = ($event) => (toogleOpenRecovery2fa(true)))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('login.login.havingProblem')), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_unref(OrButton), {
                                class: "md:self-start",
                                variant: "link",
                                onClick: logout
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('login.login.Use different email')), 1)
                                ]),
                                _: 1
                            })
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_unref(OrLogo), { class: "self-center md:hidden mb-md" }),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t('session_expire.Your session has expired')), 1),
                                (!_ctx.userIdentityProvider)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t(`session_expire.${_ctx.titleText}`)), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`session_expire.${_ctx.titleText['Due to inactivity']}`)) + " ", 1),
                                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.titleText['Provider name']), 1),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`session_expire.${_ctx.titleText['user or sign out']}`)), 1)
                                    ]))
                            ]),
                            (!_ctx.userIdentityProvider)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createVNode(_unref(OrInput), {
                                        "model-value": _ctx.username,
                                        label: _ctx.$t('session_expire.Email'),
                                        readonly: ""
                                    }, null, 8, ["model-value", "label"]),
                                    _createVNode(_unref(OrInput), {
                                        ref: "passwordInput",
                                        modelValue: password.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((password).value = $event)),
                                        class: "password",
                                        type: "password",
                                        placeholder: _ctx.$t('session_expire.Enter password'),
                                        label: _ctx.$t('session_expire.Password'),
                                        error: _ctx.error,
                                        disabled: _ctx.loading,
                                        onKeyup: _withKeys(submit, ["enter", "native"])
                                    }, null, 8, ["modelValue", "placeholder", "label", "error", "disabled"]),
                                    _createElementVNode("div", _hoisted_16, [
                                        _createVNode(_unref(OrCheckbox), {
                                            "model-value": _ctx.keepLoggedIn,
                                            class: "keep-logged-in grey",
                                            disabled: _ctx.loading,
                                            "onUpdate:modelValue": updateKeepLoggedIn
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('login.login.Keep me signed in')), 1)
                                            ]),
                                            _: 1
                                        }, 8, ["model-value", "disabled"]),
                                        _createVNode(_unref(OrButton), {
                                            variant: "link",
                                            onClick: _withModifiers(showForgotPopup, ["prevent"])
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('login.login.forgotPassword')), 1)
                                            ]),
                                            _: 1
                                        })
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_17, [
                                (!_ctx.userIdentityProvider)
                                    ? (_openBlock(), _createBlock(_unref(OrButton), {
                                        key: 0,
                                        loading: _ctx.loading,
                                        class: "sign-in",
                                        onClick: submit
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('session_expire.Sign in')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["loading"]))
                                    : (_openBlock(), _createBlock(_unref(OrButton), {
                                        key: 1,
                                        loading: _ctx.loading,
                                        class: "sign-in",
                                        onClick: loginWithProvider
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('session_expire.Sign in')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["loading"])),
                                (_ctx.googleLogin && !_ctx.twoFactorCheck)
                                    ? (_openBlock(), _createBlock(GoogleLogin, {
                                        key: 2,
                                        "verification-code": verificationCode.value,
                                        "button-type": "outlined",
                                        label: _ctx.$t('login.login.Sign in with Google'),
                                        loading: _ctx.googleLoading
                                    }, null, 8, ["verification-code", "label", "loading"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createVNode(_unref(OrButton), {
                                class: "md:self-start",
                                variant: "link",
                                onClick: logout
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('login.login.Use different email')), 1)
                                ]),
                                _: 1
                            })
                        ])),
                    _createVNode(_unref(OrModal), {
                        size: "s",
                        "is-open": isOpenRecovery2fa.value,
                        class: "recovery-modal",
                        onClose: _cache[5] || (_cache[5] = ($event) => (toogleOpenRecovery2fa(false)))
                    }, {
                        header: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.login.accessRecovery')), 1)
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.login.ifYouHaveProblems')), 1),
                                _createVNode(_unref(OrInput), {
                                    modelValue: recoveryCode.value,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((recoveryCode).value = $event)),
                                    modelModifiers: { trim: true },
                                    error: recoveryError.value,
                                    placeholder: _ctx.$t('login.login.enterRecoveryCode'),
                                    label: _ctx.$t('login.login.recoveryCode'),
                                    onKeyup: _withKeys(submit, ["enter", "native"])
                                }, null, 8, ["modelValue", "error", "placeholder", "label"]),
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('login.login.ifYouveLost')), 1)
                            ])
                        ]),
                        footer: _withCtx(() => [
                            _createElementVNode("div", _hoisted_19, [
                                _createVNode(_unref(OrButton), {
                                    variant: "outlined",
                                    class: "flex-1 md:!flex-none",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (toogleOpenRecovery2fa(false)), ["prevent"]))
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('login.login.cancel')), 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_unref(OrButton), {
                                    color: "primary",
                                    class: "flex-1 md:!flex-none",
                                    loading: _ctx.loading,
                                    onClick: _withModifiers(submit, ["prevent"])
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('login.login.submit')), 1)
                                    ]),
                                    _: 1
                                }, 8, ["loading"])
                            ])
                        ]),
                        _: 1
                    }, 8, ["is-open"]),
                    _createVNode(PasswordRecovery, {
                        ref_key: "resetPasswordModal",
                        ref: resetPasswordModal,
                        "redirect-path": _ctx.redirectPath
                    }, null, 8, ["redirect-path"])
                ])
            ]));
        };
    }
});
